import type { ReactNode } from 'react'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

// Both tabs lead with these columns, so switching tabs leaves them where they were.
export const NAME_COLUMN_CLASS = 'w-1/3'
export const STATUS_COLUMN_CLASS = 'w-40'

interface CustomerListCardProps {
  /** Sits beside the title. */
  action?: ReactNode
  /** The search box and filter selects above the table. */
  filters: ReactNode
  /** The table and its pager. */
  children: ReactNode
}

/** The card both customer tabs render in, so switching between them changes only the rows. */
export function CustomerListCard({ action, filters, children }: CustomerListCardProps) {
  return (
    <Card>
      <CardHeader className="px-4 sm:px-6">
        {/* A button's height with or without one, so the filters start on the same line in every tab. */}
        <div className="flex min-h-10 items-center justify-between gap-3">
          <CardTitle>Customers</CardTitle>
          {action}
        </div>
        <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">{filters}</div>
      </CardHeader>
      <CardContent className="px-4 sm:px-6">{children}</CardContent>
    </Card>
  )
}
